<template>
  <div>
    <paged-report-panel
      class="generic-tab"
      v-model="pagedFilter"
      :total-rows="totalRecords"
      :loading="loading"
      :search-placeholder="$t('reports.diagnostics-history.search')"
      :search-term-property="'genericSearch'"
      @input="onRefreshSearch"
    >
      <s-loader
        v-show="loading"
        class="generic-tab__loader"
        size="lg"
      />
      <additional-fields-table
        v-show="!loading"
        class="generic-tab__table"
        :items="items"
        :fields="fields(module)"
        :additional-fields-to-show="additionalFieldsToShow"
      />
    </paged-report-panel>
  </div>
</template>

<script>
import PagedReportPanel from '@/domain/components/generalPanel/reports/PagedReportPanel';
import AdditionalFieldsTable from '@/domain/components/generalPanel/reports/additionalFields/AdditionalFieldsTable';
import diagnosticsHistoryFields from '@/domain/data/generalPanel/reports/diagnosticsHistory/diagnosticsHistoryFields';
import { additionalFieldsMap } from 'sigma-mappings';

export default {
  name: 'GenericAssetHistoryTab',
  components: {
    AdditionalFieldsTable,
    PagedReportPanel,
  },
  props: {
    module: {
      type: String,
      default: null,
    },
    diagnosticsHistory: {
      type: Object,
      default: () => ({}),
    },
    filter: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    pagedFilter: {
      page: 1,
      pageSize: 100,
      filter: {},
    },
  }),
  computed: {
    items() {
      return this.diagnosticsHistory.data || [];
    },
    totalRecords() {
      return this.diagnosticsHistory.total;
    },
    additionalFieldsToShow() {
      const additionalFields = Object.values(additionalFieldsMap);
      return additionalFields.filter(
        field => this.items.some(item => item[field] !== undefined),
      );
    },
  },
  methods: {
    fields(module) {
      const fields = diagnosticsHistoryFields(this)[module];
      return (fields || []).filter(
        field => !field.normFilterKey || (this.filter.norms || []).includes(field.normFilterKey),
      );
    },
    onRefreshSearch(input) {
      this.pagedFilter = input;
      this.refreshData();
    },
    refreshData() {
      this.$emit('refresh-data', this.pagedFilter);
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/mobile-first"
  .generic-tab
    &__table
      height: 50vh
      max-height: unset
      +media-min-2xl
        height: 62vh
    &__loader
      height: 55vh
    ::v-deep
      th
        white-space: nowrap
      th:last-child
        text-align: center !important
      td span
        max-width: 350px
        width: max-content
        display: block
        text-align: center
        margin: auto
      td:first-child span
        margin: unset
</style>
